<template>
	<span class="offer-reporter" @click.prevent="openModal">{{ $t('WEBAPP_REPORT_BADOFFERS') }}</span>
</template>

<script setup lang="ts">
import { ObjectType, UpcomingRelease } from '@/@types/graphql-types';

import OfferReporterModal from '@/components/modals/offer-reporter/OfferReporterModal.vue';

import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';

const props = withDefaults(
	defineProps<{
		titleId: string;
		titleObjectId: number;
		titleObjectType: ObjectType;
		titleName: string;
		titleOffers?: TitleOfferFragment[] | UpcomingRelease[];
		additionalContexts?: SnowplowContext[];
	}>(),
	{
		titleOffers: () => [],
		additionalContexts: () => [] as SnowplowContext[],
	}
);

function openModal() {
	ModalHelper.openModal(
		OfferReporterModal,
		{
			titleId: props.titleId,
			titleObjectId: props.titleObjectId,
			titleObjectType: props.titleObjectType,
			titleName: props.titleName,
			titleOffers: props.titleOffers,
		},
		{},
		'',
		false,
		props.additionalContexts
	);
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.offer-reporter {
	font-size: 13.5px;
	padding-inline-start: 0;
	color: $jw-color-lightblue;
	cursor: pointer;
	border: none;
	background: none;
	margin-top: 0 !important;

	&:hover {
		color: white;
	}

	@media (max-width: 550px) {
		font-size: 11px;
	}
}
</style>
